<template>
  <span>
    <div class="alert_bannr">
      <img class="pc" :class="{is_link: is_link}" @click="open_page1" :src="`/img/top_banner/pc01.png?v=${version}`">
      <img class="sp" :class="{is_link: is_link}" @click="open_page1" :src="`/img/top_banner/sp01.png?v=${version}`">
    </div>
    <div class="alert_bannr">
      <img class="pc" :class="{is_link: is_link}" @click="open_page2" :src="`/img/top_banner/pc02.png?v=${version}`">
      <img class="sp" :class="{is_link: is_link}" @click="open_page2" :src="`/img/top_banner/sp02.png?v=${version}`">
    </div>
    <div class="alert_bannr_harf">
      <img class="pc" :class="{is_link: is_link}" @click="open_tiktok" :src="`/img/top_banner/pc_tiktok.png?v=${version}`">
      <img class="sp" :class="{is_link: is_link}" @click="open_tiktok" :src="`/img/top_banner/sp_tiktok.png?v=${version}`">
      <img class="pc" :class="{is_link: is_link}" @click="open_instagram" :src="`/img/top_banner/pc_instagram.png?v=${version}`">
      <img class="sp" :class="{is_link: is_link}" @click="open_instagram" :src="`/img/top_banner/sp_instagram.png?v=${version}`">
    </div>
  </span>
</template>

<script>
export default {
  props: {
    version: {
      type: Number,
      default: 0,
    },
    is_link: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    open_page1() {
      window.open('https://minny-online-store.iranoan.com/');
    },
    open_page2() {
      this.$router.push('/my-page');
    },
    open_tiktok() {
      window.open('https://www.tiktok.com/@get24757');
    },
    open_instagram() {
      window.open('https://www.instagram.com/get24_iranoan/');
    },
  },
};
</script>

<style lang="scss" scoped>
span {
  zoom: 0.75;
  @media screen and (max-width: $tabletWidth) {
    zoom: 1;
  }
}
.alert_bannr {
  text-align: center;
  margin: 5px 20px;
  img {
    border-radius: 10px;
    width: 100%;
    max-width: 1200px;
    margin: auto;
  }
}
.alert_bannr_harf {
  text-align: center;
  display: flex;
  justify-content: center;
  margin: 5px 20px;
  img {
    width: 100%;
    max-width: 600px;
    @media screen and (max-width: $tabletWidth) {
      width: 50%;
    }
  }
}
.pc {
  display: block;
}
.sp {
  display: none;
}
.is_link {
  cursor: pointer;
}
@media screen and (max-width: $tabletWidth) {
  .pc {
    display: none;
  }
  .sp {
    display: block;
  }
}
</style>
